import { render } from "./market.vue?vue&type=template&id=83e77f6a&scoped=true"
import script from "./market.vue?vue&type=script&lang=js"
export * from "./market.vue?vue&type=script&lang=js"

import "./market.vue?vue&type=style&index=0&id=83e77f6a&lang=scss"
import "./market.vue?vue&type=style&index=1&id=83e77f6a&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83e77f6a"]])

export default __exports__